import { StateViewModel } from '../StateViewModel'
import { action, computed, makeObservable, observable } from 'mobx'
import {
  IApiServiceStateViewModel,
  StateViewModelParams,
} from '../mobxUtils.types'

export class APIServiceStateViewModel<T, E = unknown | undefined>
  implements IApiServiceStateViewModel<T, E>
{
  private stateViewModel: StateViewModel<T>
  @observable private _isFirstLoading = true
  @observable private _status: IApiServiceStateViewModel<T, E>['status'] =
    'IDLE'
  @observable private _error: E | undefined

  constructor(options?: StateViewModelParams<T>) {
    makeObservable(this)
    this.stateViewModel = new StateViewModel<T>({
      options: {
        observableType: 'ref',
        clone: false,
        ...(options?.options || {}),
      },
      ...options,
    })
  }

  @computed
  public get state() {
    return this.stateViewModel.state
  }

  public setState = (state: T) => {
    this.stateViewModel.setState(state)
  }

  @computed
  public get status() {
    return this._status
  }
  @action
  public setStatus = (status: typeof this._status) => {
    this.setIsFirstLoading(this.status === 'IDLE')
    this._status = status
  }

  @computed
  public get isFirstLoading() {
    return this._isFirstLoading
  }

  @action
  public setIsFirstLoading = (isFirstLoading: typeof this._isFirstLoading) => {
    this._isFirstLoading = isFirstLoading
  }

  @computed
  public get error() {
    return this._error
  }
  @action
  public setError = (error: typeof this._error) => {
    this._error = error
  }

  @action
  public clearData = () => {
    this.setStatus('IDLE')
    this.setError(undefined)
    this.stateViewModel.clearState()
  }
}
